"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _api = require("@react-google-maps/api");

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _GoogleMapApiWrapper = _interopRequireDefault(require("../GoogleMapApiWrapper/GoogleMapApiWrapper"));

var _excluded = ["googleApiKey", "onLoadCallback", "options", "width", "height", "bg", "center", "onCenterChange", "onMouseOver", "onClick", "onDragStart", "mapContainerStyle", "onZoomChanged", "clickableIcons", "zoom", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var defaultContainerStyle = {
  width: "100%",
  height: "100%"
};
var defaultCenter = {
  lat: 51.5073509,
  lng: -0.1277583
};

var RenderMap = function RenderMap(_ref) {
  var onLoadCallback = _ref.onLoadCallback,
      children = _ref.children,
      options = _ref.options,
      center = _ref.center,
      zoom = _ref.zoom,
      onCenterChange = _ref.onCenterChange,
      onClick = _ref.onClick,
      onDragStart = _ref.onDragStart,
      onMouseOver = _ref.onMouseOver,
      onZoomChanged = _ref.onZoomChanged,
      mapContainerStyle = _ref.mapContainerStyle,
      clickableIcons = _ref.clickableIcons;
  // Providing a loadedCallback is useful in case you want to access `window.google`
  // to eg. setup options or create latLng object, it won't be available otherwise
  // feel free to render directly if you don't need that
  var onLoad = (0, _react.useCallback)(function (mapInstance) {
    if (onLoadCallback) {
      onLoadCallback({
        googleInstance: window.google,
        mapInstance: mapInstance
      });
    }
  }, [onLoadCallback]);
  return /*#__PURE__*/_react["default"].createElement(_api.GoogleMap, {
    mapContainerStyle: mapContainerStyle,
    center: center,
    onLoad: onLoad,
    options: options,
    zoom: zoom,
    onCenterChanged: onCenterChange,
    onClick: onClick,
    onMouseOver: onMouseOver,
    onDragStart: onDragStart,
    onZoomChanged: onZoomChanged,
    clickableIcons: clickableIcons
  }, children);
};
/**
 * A component to show a Google map which can be used to display directions, locations, vectors, layers and more.
 *
 * If more than one Google API components are used on the same page, it is recommened you wrap all the API components
 * in the GoogleMapApiWrapper to avoid multiple Google API requests which can cause errors.
 *
 * Do not provide the googleApiKey prop to this component if wrapped.
 *
 * Refer to @react-google-maps/api Github documentation.
 * @summary Google Map
 * @param {object} props - Component props
 * @param {string=} props.googleApiKey - A Google API key that must be authenticated to use the correct API's. Do not provide if this component is wrapped with GoogleMapApiWrapper.
 * @param {function=} props.onLoadCallback - A callback for when the component has loaded.
 * @param {object=} props.options - Options to be passed into the component, refer to Google Map API.
 * @param {string|number} [props.width = "100%"] - Width of component.
 * @param {string|number} [props.height="100%"] - Height of component.
 * @param {string} [props.bg = "dark.4"] - Background color of Flexbox containing map component.
 * @param {object} props.center - Center coordinates of viewport.
 * @param {number} [props.center.lat = 51.5073509] - Latitude coordinate.
 * @param {number} [props.center.lng = -0.1277583] - Longitude coordinate.
 * @param {function=} props.onCenterChange - Callback for when the center of map is changed by user.
 * @param {function=} props.onMouseOver - Callback for when mouse is over component.
 * @param {function=} props.onClick - Callback for when mouse clicks component.
 * @param {function=} props.onDragStart - Callback for when map is dragged by user.
 * @param {function=} props.onZoomChanged - Callback for when zoom level is changed by user.
 * @param {object=} props.mapContainerStyle - Style options passed to map.
 * @param {boolean} [props.clickableIcons = True] - Can be provided to stop a user clicking on labels within map.
 * @param {number} [props.zoom = 8] - Zoom level of map.
 * @param {Element=} props.children - Children components to be passed into map component. Refer to @react-google-maps/api Github documentation.
 */


var Map = function Map(_ref2) {
  var googleApiKey = _ref2.googleApiKey,
      onLoadCallback = _ref2.onLoadCallback,
      _ref2$options = _ref2.options,
      options = _ref2$options === void 0 ? {} : _ref2$options,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? "100%" : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === void 0 ? "100%" : _ref2$height,
      _ref2$bg = _ref2.bg,
      bg = _ref2$bg === void 0 ? "dark.4" : _ref2$bg,
      _ref2$center = _ref2.center,
      center = _ref2$center === void 0 ? defaultCenter : _ref2$center,
      onCenterChange = _ref2.onCenterChange,
      onMouseOver = _ref2.onMouseOver,
      onClick = _ref2.onClick,
      onDragStart = _ref2.onDragStart,
      _ref2$mapContainerSty = _ref2.mapContainerStyle,
      mapContainerStyle = _ref2$mapContainerSty === void 0 ? defaultContainerStyle : _ref2$mapContainerSty,
      onZoomChanged = _ref2.onZoomChanged,
      _ref2$clickableIcons = _ref2.clickableIcons,
      clickableIcons = _ref2$clickableIcons === void 0 ? true : _ref2$clickableIcons,
      _ref2$zoom = _ref2.zoom,
      zoom = _ref2$zoom === void 0 ? 8 : _ref2$zoom,
      children = _ref2.children,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, _excluded);

  var renderMapComponent = function renderMapComponent() {
    return /*#__PURE__*/_react["default"].createElement(RenderMap, {
      onLoadCallback: onLoadCallback,
      options: options,
      center: center,
      zoom: zoom,
      onCenterChange: onCenterChange,
      onClick: onClick,
      onDragStart: onDragStart,
      onMouseOver: onMouseOver,
      onZoomChanged: onZoomChanged,
      mapContainerStyle: mapContainerStyle,
      clickableIcons: clickableIcons
    }, children);
  };

  if (googleApiKey) {
    return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
      justifyContent: "center",
      alignItems: "center",
      width: width,
      height: height,
      bg: bg
    }, props), /*#__PURE__*/_react["default"].createElement(_GoogleMapApiWrapper["default"], {
      googleApiKey: googleApiKey
    }, renderMapComponent()));
  }

  return /*#__PURE__*/_react["default"].createElement(_Flex["default"], (0, _extends2["default"])({
    justifyContent: "center",
    alignItems: "center",
    width: width,
    height: height,
    bg: bg
  }, props), renderMapComponent());
};

var _default = Map;
exports["default"] = _default;